<template>
  <div>
    <div class="flex-col gap-md pr-xl" v-if="!loading">
      <dd-card>
        <dd-input title="Naam" v-model="form.name"></dd-input>
        <dd-textarea
          class="mt-sm"
          title="Beschrijving"
          v-model="form.description"
        ></dd-textarea>
      </dd-card>
      <dd-card
        v-for="(taskListTemplate, index) in taskListTemplates"
        class="flex-row"
        :key="index"
      >
        <div class="flex-row justify-content-center gap-md align-items-end">
          <dd-select
            :title="`Taak ${index + 1}`"
            label="Kies een taken template"
            :options="getAvailableTemplates"
            v-model="taskListTemplate.value"
            class="flex-stretch"
          ></dd-select>
          <dd-rounded-button
            @click="taskListTemplates.splice(index, 1)"
            icon="mdi mdi-delete"
            type="danger"
          >
          </dd-rounded-button>
        </div>
      </dd-card>
      <div class="flex-row gap-md">
        <dd-button
          @click="taskListTemplates.push({ value: null })"
          type="success"
        >
          Taak toevoegen
        </dd-button>
        <dd-button @click="saveTaskListTemplate"> Opslaan</dd-button>
      </div>
    </div>
    <dd-loading-indicator v-else></dd-loading-indicator>
  </div>
</template>

<script>
import taskTemplateApi from "~/api/task_template";
import taskListTemplateApi from "~/api/task_list_template";

export default {
  props: {
    taskList: Object | null,
  },
  data() {
    return {
      availableTemplates: null,
      taskListTemplates: [{ value: null }, { value: null }],
      newTaskTemplate: null,
      form: {
        name: null,
        description: null,
      },
      loading: false,
      loadingSubmit: false,
    };
  },
  mounted() {
    this.fetchTaskTemplates();

    if (this.taskList) {
      this.form.name = this.taskList.name;
      this.form.description = this.taskList.description;

      this.taskListTemplates = this.taskList.task_list_item_templates.map(
        (item) => {
          return {
            value: item.task_template_id,
          };
        }
      );
    }
  },
  methods: {
    async saveTaskListTemplate() {
      this.form.task_template_ids = this.taskListTemplates.map(
        (object) => object.value
      );

      let response;

      if (this.taskList && this.taskList.id) {
        response = await taskListTemplateApi.update(
          this.taskList.id,
          this.form
        );
      } else {
        response = await taskListTemplateApi.save(this.form);
      }

      window.location.href = response.location;
    },
    async fetchTaskTemplates() {
      this.loading = true;
      try {
        let response = await taskTemplateApi.get([
          "users",
          "departments",
          "product_labels",
        ]);

        this.availableTemplates = response.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    getAvailableTemplates() {
      return this.availableTemplates
        ? this.availableTemplates
            .filter((template) => template.for_task_list_template)
            .map((template) => {
              return {
                value: template.id,
                label: template.name,
              };
            })
        : [];
    },
  },
};
</script>

<style scoped></style>
